<template>
  <div>
    <div>
      <label>
        {{$t('entities.inputs.name')}}:
      </label>
      <span class="is-bold">
        {{entity.name}}
      </span>
    </div>
    <div>
      <label>
        {{$t('entities.inputs.nif')}}:
      </label>
      <span class="is-bold">
        {{entity.nif}}
      </span>
    </div>
    <div>
      <label>
        {{$t('entities.inputs.language')}}:
      </label>
      <span class="is-bold">
        {{getFormattedLanguage()}}
      </span>
    </div>
    <div>
      <label>
        {{$t('entities.inputs.id')}}:
      </label>
      <span class="is-bold">
        {{entity.id}}
      </span>
    </div>
    <div>
      <label>
        {{$t('entities.inputs.users_count')}}:
      </label>
      <span class="is-bold">
        {{entity.users_count}}/{{entity.users_limit}}
      </span>
    </div>
    <div>
      <label>
        {{$t('entities.inputs.activities_received')}}:
      </label>
      <li class="is-bold ml-4" v-for="activity in activitiesReceived" :key="activity">
        {{$t(`entities.activity_types.${activity}`)}}
      </li>
    </div>
  </div>
</template>
<script>
import { ActivityService } from '@/api/AuthService'
export default {
  props: {
    entity: {
      type: Object,
      required: true
    }
  },
  computed: {
    activitiesReceived: function () {
      let uniqueActivityIds = Array.from(new Set(this.entity.activity_providers.map(element => element.activity_id))).sort()
      return uniqueActivityIds
    }
  },
  methods: {
    getFormattedLanguage: function () {
      if (this.entity.lang) {
        let language = this.$store.state.languages.find(elem => elem.lang === this.entity.lang.toLowerCase())
        return `${this.$t('language.' + language.language_key)} ${language.emoji}`
      }
      return 'N/A'
    }

  }
}
</script>
